/* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
export const noop = function () {
  /* empty */
};
//# sourceMappingURL=noop.js.map